module.exports = __webpack_public_path__ + "static/media/academic.1f5ff3ad.png";